import React, { lazy, Suspense, useContext } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { AuthContext } from './Component/Auth/authContext';
import Login from './Component/Login/Login';

const Calendario = lazy(() => import('./Component/Calendario/Calendario'));

const PageLoader = () => (
  <div className="page-loader" role="status" aria-live="polite">
    <div className="spinner-border text-primary" aria-hidden="true" />
    <span>Caricamento agenda…</span>
  </div>
);

function App() {
  const { currentUser } = useContext(AuthContext);

  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={currentUser ? <Navigate to="/calendario" replace /> : <Login />} />
          <Route path="/calendario" element={currentUser ? <Calendario /> : <Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to={currentUser ? '/calendario' : '/'} replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
